import { Injectable, inject, signal } from '@angular/core';
import { RemoteConfig, fetchAndActivate, getAll } from '@angular/fire/remote-config';

export interface FeatureFlags {
  bypassTranscriptionModelSelection: boolean;
  zoomVideoRecording: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  private remoteConfig: RemoteConfig = inject(RemoteConfig, { optional: true });
  private readonly defaultFlags: FeatureFlags = {
    bypassTranscriptionModelSelection: true,
    zoomVideoRecording: false,
  };
  private featureFlags = signal<FeatureFlags>(this.defaultFlags);

  constructor() {
    this.init();
  }

  private async init(): Promise<void> {
    if (!this.remoteConfig) {
      console.warn('Firebase Remote Config is not initialized. Using default feature flags.');
      return;
    }
    try {
      await fetchAndActivate(this.remoteConfig);
      const remoteValues = getAll(this.remoteConfig);
      const newFlags: Partial<FeatureFlags> = {};
      for (const key in this.defaultFlags) {
        if (Object.prototype.hasOwnProperty.call(remoteValues, key)) {
          newFlags[key as keyof FeatureFlags] = remoteValues[key].asBoolean();
        }
      }
      this.featureFlags.update((flags) => ({ ...flags, ...newFlags }));
    } catch (error) {
      console.error('Firebase Remote Config failed to initialize. Using default feature flags.', error);
    }
  }

  isFeatureEnabled(flagName: keyof FeatureFlags): boolean {
    return this.featureFlags()[flagName];
  }
}
